import { ReactComponent as ScreenIcon } from 'assets/svg/screen.svg';
import { ReactComponent as BookIcon } from 'assets/svg/book.svg';

export const CORONA_CRASH = 'coronaCrash';
export const MONEY_FACTORY = 'moneyFactory';
export const INFLATION = 'inflation';
export const GENERATION_Y = 'generationY';
export const GIFT_CARD = 'giftCard';
export const BANKS_FALTER = 'banksFalter';
export const CURRENCIES = 'currencies';
export const LOOK_FOR_HEALTH = 'lookFprHealth';
export const LOOK_FOR_HEALTH_FLIP_BOOK = 'lookFprHealthFlipBook';
export const MONEY_COMBO_1 = 'moneyCombo1';
export const MONEY_COMBO_2 = 'moneyCombo2';
export const MONEY_COMBO_3 = 'moneyCombo3';
export const SWITZERLAND_CARES_FOR = 'switzerland-cares-for';
export const BRILLIANT_PROSPECTS = 'brilliantProspects';
export const BITCOIN_CRYPTO = 'bitcoinCrypto';
export const SEARCH_FOR_WEALTH = 'searchForWealth';
export const SUDDEN_MONEY = 'suddenMoney';
export const BULLS_BEARS_BEGINNERS = 'bullsBearsBeginners';
export const HOW_TO_INVEST_MONEY = 'howToInvestMoney';
export const HOW_TO_INVEST_MONEY_FRENCH = 'howToInvestMoneyFrench';
export const HOW_TO_INVEST_BONDS = 'howToInvestBonds';
export const INTRODUCTION_FINANCIAL_MATHEMATICS = 'introductionFinancialMathematics';
export const INTRODUCTION_FINANCIAL_MATHEMATICS_ENGLISH = 'introductionFinancialMathematicsEnglish';

export const REGISTER = 'register';
export const ONLY_PURCHASE = 'onlyPurchase';
export const LOGIN = 'login';
export const ADDRESS = 'address';
export const PAYMENT = 'payment';
export const PREMIUM_OFFER = 'premiumOffer';
export const THANKS = 'thanks';

export const PRINTED_BOOK = 'printedBook';
export const GIFT_BOOK = 'giftBook';
export const FLIP_BOOK = 'flipBook';
export const ACCOUNT_BOOK = 'accountBook';

export const ALL = 'all';
export const FLIP_BOOKS = 'flipBooks';
export const SMART_BOOKS = 'smartBooks';

export const ID = '_id';
export const FIRST_NAME = 'firstname';
export const LAST_NAME = 'lastname';
export const ZIP_CODE = 'zipCode';
export const CITY = 'city';
export const COUNTRY = 'country';
export const EMAIL = 'email';
export const PASSWORD = 'password';
export const VOUCHER = 'voucher';
export const WISH_PREMIUM = 'WITH_PREMIUM';
export const PRODUCT_ID = 'productId';
export const PURCHASE_OPTION = 'purchaseOption';
export const PAYMENT_OPTION = 'paymentOption';

export const MARKET_VOUCHER = 'MARXCR';
export const PROCESSION_VOUCHER = 'FTXCOR';

export const ORDER_OBJECT = {
  [PRINTED_BOOK]: 'SmartBook',
  [GIFT_BOOK]: 'As a gift',
  [FLIP_BOOK]: 'FlipBook',
  [ACCOUNT_BOOK]: 'For my Fintool account',
};

export const BOOK_FORMATS = {
  [FLIP_BOOKS]: {
    name: 'FlipBook',
    title: 'What is a FlipBook',
    text: 'They are more than just digital books or eBooks',
    title2: 'Can I give a FlipBook as a gift',
    text2: 'You can easily give a FlipBook as a gift',
    icon: ScreenIcon,
    iconColor: '#b7d9ff',
  },
  [SMART_BOOKS]: {
    name: 'SmartBook',
    title: 'What is a SmartBook',
    text: 'These are printed books that contain smart functions',
    icon: BookIcon,
    iconColor: '#ffdddd',
  },
};

export const BOOK_FILTERS = [
  { id: ALL, name: '', icons: [BookIcon, ScreenIcon] },
  { id: FLIP_BOOKS, name: 'FlipBooks', icons: [ScreenIcon] },
  { id: SMART_BOOKS, name: 'SmartBooks', icons: [BookIcon] },
];
